/**
 * Mock follow service.
 * Mirrors the real follow.service.js API with in-memory data.
 */
import { MOCK_USERS, MOCK_CURRENT_USER_ID } from '../../data/mock/mock-users.data';
import { mockDelay, mockLog } from './mock-delay';

// In-memory following state. Current user follows some mock users by default.
const followingMap = new Map();
followingMap.set(MOCK_CURRENT_USER_ID, new Set([
  'mock_user_002', 'mock_user_003', 'mock_user_005', 'mock_user_007', 'mock_user_010',
]));

const getFollowingSet = (userId) => {
  if (!followingMap.has(userId)) followingMap.set(userId, new Set());
  return followingMap.get(userId);
};

export const followUser = async (currentUserId, targetUserId) => {
  mockLog('FollowService', 'followUser', { currentUserId, targetUserId });
  await mockDelay();
  if (currentUserId === targetUserId) throw new Error('You cannot follow yourself.');
  getFollowingSet(currentUserId).add(targetUserId);
};

export const unfollowUser = async (currentUserId, targetUserId) => {
  mockLog('FollowService', 'unfollowUser', { currentUserId, targetUserId });
  await mockDelay();
  getFollowingSet(currentUserId).delete(targetUserId);
};

export const checkIfFollowing = async (currentUserId, targetUserId) => {
  mockLog('FollowService', 'checkIfFollowing', { currentUserId, targetUserId });
  await mockDelay(50, 150);
  return getFollowingSet(currentUserId).has(targetUserId);
};

export const getFollowers = async (userId, lastDoc = null, pageLimit = 20) => {
  mockLog('FollowService', 'getFollowers', userId);
  await mockDelay();
  // Find all users that follow the given userId
  const followers = MOCK_USERS.filter((u) => {
    const set = followingMap.get(u.id);
    return set && set.has(userId);
  });
  return { followers, lastDoc: null, hasMore: false };
};

export const getFollowing = async (userId, lastDoc = null, pageLimit = 20) => {
  mockLog('FollowService', 'getFollowing', userId);
  await mockDelay();
  const set = getFollowingSet(userId);
  const following = MOCK_USERS.filter((u) => set.has(u.id));
  return { following, lastDoc: null, hasMore: false };
};

export const getFollowingIds = async (userId) => {
  mockLog('FollowService', 'getFollowingIds', userId);
  await mockDelay(50, 200);
  return Array.from(getFollowingSet(userId));
};

export const getSuggestedUsers = async (currentUserId, resultLimit = 5) => {
  mockLog('FollowService', 'getSuggestedUsers', currentUserId);
  await mockDelay();
  const followingSet = getFollowingSet(currentUserId);
  return MOCK_USERS
    .filter((u) => u.id !== currentUserId && !followingSet.has(u.id))
    .slice(0, resultLimit);
};
